import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import * as d3v4 from 'd3';
import { Link } from 'react-router-dom';
import SoccerPitch from '.././components/SoccerPitch';
import { Img } from '.././components/Common';
import VideoStreamTV from '.././components/VideoStreamTV';
import './Test.css';
import * as adapter from 'webrtc-adapter';

const { d3 } = window

/*const proto = Object.create(HTMLElement.prototype, {
    attachedCallback: {
        value: function () {
            const mountPoint = document.createElement('span');
            this.createShadowRoot().appendChild(mountPoint);

            const name = this.getAttribute('name');
            const url = 'https://www.google.com/search?q=' + encodeURIComponent(name);
            ReactDOM.render(<a href={url}>{name}</a>, mountPoint);
        }
    }
});
document.registerElement('x-search', { prototype: proto });*/

export default class TestView extends Component {
    constructor(p) {
        super(p)
        this.state = {
            isTop: false
        }
    }

    componentDidMount() {
        FakeData.$("#myVideo");
        //var connection = new WebSocket('ws://localhost:8080/supotsu/public/server/test.socket.php', ['soap', 'xmpp']);
        //var wsUri = "ws://146.185.136.166:9000/server/testWS.php"; 	
	    //var conn = new WebSocket(wsUri);
        //conn.onmessage = function(e) { console.log(e.data); };
        //conn.onopen = function(e) { conn.send({name:"Ali",message:"Hello Me!", color:"#fff"}); };
        if(FakeData.hasUserMedia()){
            //window.navigator.getUserMedia({video:true,})
        }
    }

    consoler = (e) => {
        console.log(e)
    }

    render() {
        return (
            <div className="" style={{ width: "100vw", height: "100vh" }}>
                <VideoStreamTV />
            </div>
        );
    }
}

export class VideoStream extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.gotStream = this.gotStream.bind(this);
    }


    componentDidMount() {
        this.elem = FakeData.$("#myVideo");
        console.log(this.elem)
        //adapter.commonShim
        if(this.hasUserMedia()){
            window.navigator.getUserMedia({ audio: true, video: true }, this.gotStream, function (err) {});
        }
    }

    hasUserMedia() {
        //check if the browser supports the WebRTC 
        return !!(window.navigator.getUserMedia || window.navigator.webkitGetUserMedia ||
            window.navigator.mozGetUserMedia);
    }

    gotStream(stream) {
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioContext();

        // Create an AudioNode from the stream
        this.mediaStreamSource = this.audioContext.createMediaStreamSource(stream);

        // Connect it to destination to hear yourself
        // or any other node for processing!
        this.mediaStreamSource.connect(this.audioContext.destination);
        this.elem.attr("src",window.URL.createObjectURL(stream));
        this.elem.play();
    }

    render() {
        return (
            <div style={{ width: "100vw", height: "80vh" }}>
                <video style={{ width: "100vw", height: "80vh", background: "#555" }} id="myVideo" className="myvideo">

                </video>
            </div>
        );
    }
}

export class SVGBrushCrop extends Component {
    state = {
        originalImage: "http://localhost:3000/server/media/59805d73eb8da.jpg",
        newImage: ""
    }

    componentDidMount() {
        this.brush = d3v4.brush();
        console.log(this.brush)
        this.svg = d3v4.select(this.refs.root);
        this.w = this.svg.node().clientWidth;
        this.h = this.svg.node().clientHeight;
        this.svg.append("g")
            .attr("class", "brush")
            .call(this.brush)
            .call(this.brush.move, [[this.w / 4, this.h / 4], [this.w / 2, this.h / 2]])
            .select(".selection")
            .attr("id", "brush-selection");

        this.svg.append("clipPath")
            .attr("id", "brush-clip")
            .append("use")
            .attr("xlink:href", "#brush-selection");

        this.svg.select("#color-image")
            .attr("clip-path", "url(#brush-clip)");
    }

    render() {
        const { originalImage } = this.state
        return (
            <svg ref="root" style={{ background: "#555", width: "50vw", height: "50vw" }}>
                <filter id="monochrome"><feColorMatrix type="saturate" values="0"></feColorMatrix></filter>
                <defs><image id="image" width="100%" height="100%" xlinkHref={originalImage}></image></defs>
                <use id="monochrome-image" filter="url(#monochrome)" xlinkHref="#image"></use>
                <use id="color-image" xlinkHref="#image"></use>
            </svg>
        );
    }
}

export class ImageCropper extends Component {
    state = {
        originalImage: "http://orig00.deviantart.net/7098/f/2016/017/1/3/2016_01_number_one_by_w0lle-d9obk41.jpg",
        newImage: ""
    }

    constructor(props) {
        super(props);

        this.dragend = this.dragend.bind(this);
        this.dragmove = this.dragmove.bind(this);
        this.dragstart = this.dragstart.bind(this);
    }


    componentDidMount = () => {
        //console.log(d3)
        this.drag = d3.behavior.drag()
            .on('drag', this.dragmove)
            .on('dragstart', this.dragstart)
            .on('dragend', this.dragend);

        this.root = d3.select(this.refs.root);
        this.w = this.root.node().clientWidth;
        this.h = this.root.node().clientHeight;
        this.root.append('use').attr('xlink:href', '#img');

        this.image = this.root.select("#img").call(this.drag);

        this.selection = this.root.append('rect')
            .classed('selection', true)
            .attr('fill', 'white').
            call(
            d3.behavior.drag().on("dragstart", this.dragstarted)
                .on("drag", this.dragged)
                .on("dragend", this.dragended)
            );

        this.clip = this.root.select('#clip').append('rect');

        this.startX = 0;
        this.startY = 0;
        this.currentX = 0;
        this.currentY = 0;
        this.translate = [];

        this.init()
    }

    init = () => {
        this.startX = 0;
        this.startY = 0;
        this.currentX = 0;
        this.currentY = 0;
        this.image.attr('width', this.w).attr('height', this.h).attr('clip-path', null);
        this.selection.attr('fill-opacity', 0.2).attr('width', 0).attr('height', 0);
    }

    dragstart = () => {
        const _that = this
        var m = d3.mouse(this.image[0][0]);
        //console.log(m)

        this.startX = m[0];
        this.startY = m[1];

        this.selection
            .attr('x', this.startX)
            .attr('y', this.startY);
    }

    dragmove = () => {
        var m = d3.mouse(this.image[0][0]);

        this.currentX = m[0] - this.startX;
        this.currentY = m[1] - this.startY;

        // creates an array [0, -30] where array[0] is a positive value
        this.translate[0] = this.currentX < 0 ? this.currentX : 0;
        this.translate[1] = this.currentY < 0 ? this.currentY : 0;

        this.selection.attr({
            width: Math.abs(this.currentX),
            height: Math.abs(this.currentY),
            transform: 'translate(' + this.translate[0] + ',' + this.translate[1] + ')'
        });
    }

    dragend = () => {
        this.selection.attr('fill-opacity', 0.1);

        // update clip attributes to reflect selection
        this.clip.attr({
            x: this.selection.attr('x'),
            y: this.selection.attr('y'),
            width: this.selection.attr('width'),
            height: this.selection.attr('height'),
            transform: 'translate(' + this.translate[0] + ',' + this.translate[1] + ')'
        });

        // apply clipping mask
        /*this.image.attr('clip-path', 'url(#clip)');

        this.selection.transition().duration(400).delay(200).attr('transform', 'translate(0,0)')
            .attr('width', 0)
            .attr('height', 0);*/
    }

    dragstarted = (d) => {
        //d3.select(this.selection[0][0]).raise().classed("active", true);
    }

    dragged = (d) => {
        var m = d3.mouse(this.selection[0][0]);
        this.selection.attr("x", m[0]).attr("y", m[1])
    }

    dragended = (d) => {

    }

    render() {
        const { originalImage } = this.state
        return (
            <svg ref="root" className="image-cropper-root">
                <defs>
                    <image id="img" xlinkHref="http://orig00.deviantart.net/7098/f/2016/017/1/3/2016_01_number_one_by_w0lle-d9obk41.jpg" x="0" y="0" />
                    <clipPath id="clip"></clipPath>
                </defs>
            </svg>
        );
    }
}

class RichTextInputField extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div className="" style={{ width: "100%" }}>
                {/*<RichTextInputField onTextChanged={this.consoler.bind(this)}/>*/}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Test.js